import classNames from 'classnames';
import React from 'react';
import { useParams } from 'react-router';
import { TemplateClassNames } from '../../../../../types/template-layouts';
import {
	PageModule,
} from '../../../../../types/working-model';
import { getTextValue } from '../../../../../utils/utils';
import { TypographyItem } from '../../../../general-ui/typography-item/typography-item';
import { ParamsProps } from '../../../live-event';
import { getStylingOverrides } from '../../../utils';
import DocumentCard from './document-card';
import './documents.scss';

interface IDocumentsProps {
	module: PageModule
	template: TemplateClassNames;
}

const SessionDocuments: React.FC<IDocumentsProps> = ({ module, template }) => {
	const { language }: ParamsProps = useParams();
	const stylingOverrides = getStylingOverrides(module?.styling_overrides);
	const { custom_heading } = getTextValue(module.content, language);

	if (!module.modules) return null;
	return (
		<div className={classNames(
			"documents session-module",
			stylingOverrides.backgroundColor,
			template
		)}
			style={stylingOverrides.backgroundImg}
		>
			<TypographyItem
				tagName="h5"
				template={template}
				className={classNames(
					"documents-custom_heading evt-heading-5",
					stylingOverrides.customHeadingOverrides
				)}>
				{custom_heading || "Documents"}
			</TypographyItem>
			<div className="documents-content">
				<div className="documents-list">
					{module.modules?.map((document) => (
						<DocumentCard
							key={document.document}
							template={template}
							document={document}
						/>
					))}
				</div>
			</div>
		</div >
	);
};

export default SessionDocuments;

